export const countryMapTr = {
  AF: "Afganistan",
  AX: "Åland Adaları",
  AL: "Arnavutluk",
  DZ: "Cezayir",
  AS: "Amerikan Samoası",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktika",
  AG: "Antigua ve Barbuda",
  AR: "Arjantin",
  AM: "Ermenistan",
  AW: "Aruba",
  AU: "Avustralya",
  AT: "Avusturya",
  AZ: "Azerbaycan",
  BS: "Bahamalar",
  BH: "Bahreyn",
  BD: "Bangladeş",
  BB: "Barbados",
  BY: "Beyaz Rusya",
  BE: "Belçika",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivya",
  BQ: "Bonaire, Sint Eustatius ve Saba",
  BA: "Bosna Hersek",
  BW: "Botsvana",
  BV: "Bouvet Adası",
  BR: "Brezilya",
  IO: "Britanya Hint Okyanusu Toprakları",
  BN: "Brunei",
  BG: "Bulgaristan",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kamboçya",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Cape Verde",
  KY: "Cayman Adaları",
  CF: "Orta Afrika Cumhuriyeti",
  TD: "Çad",
  CL: "Şili",
  CN: "Çin",
  CX: "Christmas Adası",
  CC: "Cocos (Keeling) Adaları",
  CO: "Kolombiya",
  KM: "Komorlar",
  CG: "Kongo",
  CD: "Demokratik Kongo Cumhuriyeti",
  CK: "Cook Adaları",
  CR: "Kosta Rika",
  CI: "Fildişi Sahili",
  HR: "Hırvatistan",
  CU: "Küba",
  CW: "Curaçao",
  CY: "Kıbrıs",
  CZ: "Çek Cumhuriyeti",
  DK: "Danimarka",
  DJ: "Cibuti",
  DM: "Dominika",
  DO: "Dominik Cumhuriyeti",
  EC: "Ekvador",
  EG: "Mısır",
  SV: "El Salvador",
  GQ: "Ekvator Ginesi",
  ER: "Eritre",
  EE: "Estonya",
  ET: "Etiyopya",
  FK: "Falkland Adaları",
  FO: "Faroe Adaları",
  FJ: "Fiji",
  FI: "Finlandiya",
  FR: "Fransa",
  GF: "Fransız Guyanası",
  PF: "Fransız Polinezyası",
  TF: "Fransız Güney Toprakları",
  GA: "Gabon",
  GM: "Gambiya",
  GE: "Gürcistan",
  DE: "Almanya",
  GH: "Gana",
  GI: "Cebelitarık",
  GR: "Yunanistan",
  GL: "Grönland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Gine",
  GW: "Gine-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Adası ve McDonald Adaları",
  VA: "Vatikan",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Macaristan",
  IS: "İzlanda",
  IN: "Hindistan",
  ID: "Endonezya",
  IR: "İran",
  IQ: "Irak",
  IE: "İrlanda",
  IM: "Man Adası",
  IL: "İsrail",
  IT: "İtalya",
  JM: "Jamaika",
  JP: "Japonya",
  JE: "Jersey",
  JO: "Ürdün",
  KZ: "Kazakistan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Kuzey Kore",
  KR: "Güney Kore",
  XK: "Kosova",
  KW: "Kuveyt",
  KG: "Kırgızistan",
  LA: "Laos",
  LV: "Letonya",
  LB: "Lübnan",
  LS: "Lesotho",
  LR: "Liberya",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Litvanya",
  LU: "Lüksemburg",
  MO: "Makao",
  MK: "Kuzey Makedonya",
  MG: "Madagaskar",
  MW: "Malavi",
  MY: "Malezya",
  MV: "Maldivler",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Adaları",
  MQ: "Martinik",
  MR: "Moritanya",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Meksika",
  FM: "Mikronezya",
  MD: "Moldova",
  MC: "Monako",
  MN: "Moğolistan",
  ME: "Karadağ",
  MS: "Montserrat",
  MA: "Fas",
  MZ: "Mozambik",
  MM: "Myanmar",
  NA: "Namibya",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Hollanda",
  NC: "Yeni Kaledonya",
  NZ: "Yeni Zelanda",
  NI: "Nikaragua",
  NE: "Nijer",
  NG: "Nijerya",
  NU: "Niue",
  NF: "Norfolk Adası",
  MP: "Kuzey Mariana Adaları",
  NO: "Norveç",
  OM: "Umman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Filistin",
  PA: "Panama",
  PG: "Papua Yeni Gine",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filipinler",
  PN: "Pitcairn",
  PL: "Polonya",
  PT: "Portekiz",
  PR: "Porto Riko",
  QA: "Katar",
  RE: "Reunion",
  RO: "Romanya",
  RU: "Rusya",
  RW: "Ruanda",
  BL: "Saint Barthelemy",
  SH: "Saint Helena, Ascension ve Tristan da Cunha",
  KN: "Saint Kitts ve Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin",
  PM: "Saint Pierre ve Miquelon",
  VC: "Saint Vincent ve Grenadinler",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome ve Principe",
  SA: "Suudi Arabistan",
  SN: "Senegal",
  RS: "Sırbistan",
  SC: "Seyşeller",
  SL: "Sierra Leone",
  SG: "Singapur",
  SX: "Sint Maarten",
  SK: "Slovakya",
  SI: "Slovenya",
  SB: "Solomon Adaları",
  SO: "Somali",
  ZA: "Güney Afrika",
  GS: "Güney Georgia ve Güney Sandwich Adaları",
  SS: "Güney Sudan",
  ES: "İspanya",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Surinam",
  SJ: "Svalbard ve Jan Mayen",
  SZ: "Esvatini",
  SE: "İsveç",
  CH: "İsviçre",
  SY: "Suriye",
  TW: "Tayvan",
  TJ: "Tacikistan",
  TZ: "Tanzanya",
  TH: "Tayland",
  TL: "Doğu Timor",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad ve Tobago",
  TN: "Tunus",
  TR: "Türkiye",
  TM: "Türkmenistan",
  TC: "Turks ve Caicos Adaları",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukrayna",
  AE: "Birleşik Arap Emirlikleri",
  GB: "Birleşik Krallık",
  US: "Amerika Birleşik Devletleri",
  UM: "ABD'nin Uzak Adaları",
  UY: "Uruguay",
  UZ: "Özbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Britanya Virjin Adaları",
  VI: "ABD Virjin Adaları",
  WF: "Wallis ve Futuna",
  EH: "Batı Sahra",
  YE: "Yemen",
  ZM: "Zambiya",
  ZW: "Zimbabve"
}